import i18n from "../../../i18n";
import { Notification } from "../../../Utils/Notification";
import { deepEqual } from "../../../Utils/object";

const handleCountMissionStatus = (drivers) => {
  const allTaskStatusDeliveryMap = drivers.reduce(
    (total, { driverLiveTrackMissionStatusOverView: mission }) => ({
      start: total.start + mission.start,
      assign: total.assign + mission.assign,
      waiting: total.waiting + mission.waiting,
      rejected: total.rejected + mission.rejected,
      canceled: total.canceled + mission.canceled,
      completed: total.completed + mission.completed,
      noReceiver: total.noReceiver + mission.noReceiver,
      halfDelivered: total.halfDelivered + mission.halfDelivered,
    }),
    {
      start: 0,
      waiting: 0,
      assign: 0,
      canceled: 0,
      rejected: 0,
      completed: 0,
      noReceiver: 0,
      halfDelivered: 0,
    }
  );

  allTaskStatusDeliveryMap.done =
    allTaskStatusDeliveryMap.rejected +
    allTaskStatusDeliveryMap.completed +
    allTaskStatusDeliveryMap.noReceiver +
    allTaskStatusDeliveryMap.halfDelivered;
  allTaskStatusDeliveryMap.total =
    allTaskStatusDeliveryMap.done +
    allTaskStatusDeliveryMap.start +
    allTaskStatusDeliveryMap.assign +
    allTaskStatusDeliveryMap.waiting +
    allTaskStatusDeliveryMap.canceled;

  return allTaskStatusDeliveryMap;
};

export const toggleSocketLiveTackIsListeningToMap = (state, action) => {
  return { ...state, socketLiveTackIsListeningToMap: action.state };
};

export const findMissionCard = (state, action) => {
  const data = {
    State: action.state,
    MissionId: action.id,
  };
  return { ...state, findMissionCard: data };
};

export const nextPrevMission = (state, action) => {
  const index = state.SingleDriver.missions.findIndex(
    (mission) => mission.packetId === action.currentPacketId
  );
  let Destination = null;
  if (action.nextOrPrev === "NEXT") {
    if (index === state.SingleDriver.missions.length - 1) {
      Destination = state.SingleDriver.missions[0];
    } else {
      Destination = state.SingleDriver.missions[index + 1];
    }
  }
  if (action.nextOrPrev === "PREV") {
    if (index === 0) {
      Destination =
        state.SingleDriver.missions[state.SingleDriver.missions.length - 1];
    } else {
      Destination = state.SingleDriver.missions[index - 1];
    }
  }

  return {
    ...state,
    LiveTrack: {
      ...state.LiveTrack,
      NextPrevMissionInfo: Destination,
      flyToMission: [
        Destination.address.latitude,
        Destination.address.longitude,
      ],
    },
  };
};

export const getLiveTrackDrivers = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, liveTrackDrivers: updateValue };
};

export const goToDriverMissionInfo = (state, action) => {
  const updateValue = { ...action.data };
  return { ...state, goToDriverMissionInfo: updateValue };
};

export const getLiveTrackDriversSuccess = (state, action) => {
  if (action.res.entity === null) {
    if (action.res.message) {
      Notification.pushNotif(
        i18n.dir() === "rtl" ? action.res?.messageFa : action.res?.message,
        "error"
      );
    } else {
      Notification.pushNotif(i18n.t("Notification.Wrong"), "error");
    }
    return;
  }

  const updateValue = {
    request: null,
    response: action.res.entity,
    error: null,
  };

  // const DriverVehicleType =
  //   state.MenuItems.vehicle === "car"
  //     ? 2
  //     : state.MenuItems.vehicle === "truck"
  //     ? 3
  //     : 1;

  const updateDrivers = [];

  action.res.entity.forEach((driver) => {
    // if (driver.vehicleType === DriverVehicleType) {
    // filter by driver type => bike - car - truck
    const Driver = {
      speed: 0, // km/h
      bearing: 0, // for driver icon
      battery: 50, // percent %
      latitude: 0, // driver coord
      longitude: 0, // driver coord
      createdAt: 0,
      gpsSignal: 3, // 1=>Poor  2=>Normal  3=>Good
      isOnline: true, // driver is online
      isGpsActive: false,
      isActive: driver.shiftStart, // driver activation status
      distributor: {
        battery: 50,
        latitude: 0,
        longitude: 0,
        gpsSignal: 3,
        isOnline: true,
        isGpsActive: false,
        ...driver.distributor,
        isActive: driver.shiftStart,
      },
      clusterId: driver.clusterId,
      driverId: driver.driverUserId,
      appVersion: driver.mobileAppVersion,
      driverName: driver.driverName,
      vehicleType: driver.vehicleType, // car - bike - truck
      driverPhoto: driver.driverPhoto,
      driverPhoneNumber: driver.driverPhoneNumber,
      MissionStatusOverView: driver.driverLiveTrackMissionStatusOverView,
    };
    updateDrivers.push(Driver);
    // }
  });
  const DriversMissionCounter = handleCountMissionStatus(action.res.entity);
  return {
    ...state,
    liveTrackDrivers: updateValue,
    Drivers: updateDrivers,
    LiveTrack: { ...state.LiveTrack, DriversMissionCounter },
  };
};

export const getLiveTrackDriversFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };

  return { ...state, liveTrackDrivers: updateValue };
};

export const DriverVehicleIsUpdated = (state) => {
  const updateDrivers = [];
  if (state.liveTrackDrivers.response) {
    state.liveTrackDrivers.response.forEach((driver) => {
      // if (driver.vehicleType === action.vehicle) {
      // filter by driver type => bike - car - truck
      const Driver = {
        speed: 0, // km/h
        bearing: 0, // for driver icon
        battery: 50, // percent %
        latitude: 0, // driver coord
        longitude: 0, // driver coord
        createdAt: 0,
        gpsSignal: 3, // 1=>Poor  2=>Normal  3=>Good
        isOnline: true, // driver is online
        isGpsActive: false,
        isActive: driver.shiftStart, // driver activation status
        distributor: {
          battery: 50,
          latitude: 0,
          longitude: 0,
          createdAt: 0,
          gpsSignal: 3,
          isOnline: true,
          isGpsActive: false,
          ...driver.distributor,
          isActive: driver.shiftStart,
        },
        clusterId: driver.clusterId,
        driverId: driver.driverUserId,
        driverName: driver.driverName,
        vehicleType: driver.vehicleType, // car - bike - truck
        driverPhoto: driver.driverPhoto,
        driverPhoneNumber: driver.driverPhoneNumber,
        MissionStatusOverView: driver.driverLiveTrackMissionStatusOverView,
      };
      updateDrivers.push(Driver);
      // }
    });
  } else {
    if (!state.liveTrackDrivers.request) {
      Notification.pushNotif(i18n.t("Notification.PlanNoDriver"), "error");
    }
  }
  return {
    ...state,
    Drivers: updateDrivers,
  };
};

export const changeLiveTrackMapDrawerTab = (state, action) => {
  return { ...state, liveTrackMapDrawerTab: action.tab };
};

export const updateLiveTrackItems = (state, action) => {
  if (action.value === state.LiveTrack[action.key]) {
    return state;
  }
  return {
    ...state,
    LiveTrack: { ...state.LiveTrack, [action.key]: action.value },
  };
};

export const updateLiveTrackDrivers = (state, action) => {
  // action.state:  1)LIVETRACK_TOPIC  2)CONNECTIVITY_TOPIC  3)ACTIVITY_SOCKET

  let UserIsDistributor = false;
  let UpdateState = false;
  let DriverIsExistForUpdate = state.Drivers.findIndex(
    (driver) => driver.driverId === action.data.driverId
  );
  if (DriverIsExistForUpdate === -1) {
    DriverIsExistForUpdate = state.Drivers.findIndex(
      (driver) =>
        driver?.distributor?.distributorUserId === action.data.driverId
    );
    if (DriverIsExistForUpdate !== -1) {
      UserIsDistributor = true;
    }
  }

  if (DriverIsExistForUpdate !== -1) {
    let driver = { ...state.Drivers[DriverIsExistForUpdate] };
    if (action.state === "ACTIVITY_SOCKET") {
      if (UserIsDistributor) {
        if (driver.distributor.isActive !== action.data.isShiftActive)
          UpdateState = true;
        else driver.distributor.isActive = action.data.isShiftActive;
      } else {
        if (driver.isActive !== action.data.isShiftActive) UpdateState = true;
        else driver.isActive = action.data.isShiftActive;
      }
    }

    if (action.state === "LIVETRACK_TOPIC") {
      if (UserIsDistributor) {
        driver = {
          ...driver,
          distributor: { ...driver?.distributor, ...action.data },
        };
        if (!deepEqual(driver, driver)) {
          UpdateState = true;
        }
      } else {
        driver = {
          ...driver,
          ...action.data,
        };
        if (!deepEqual(driver, driver)) {
          UpdateState = true;
        }
      }
    }

    if (action.state === "CONNECTIVITY_TOPIC") {
      if (UserIsDistributor) {
        if (driver.distributor.isOnline !== action.data.isOnline)
          UpdateState = true;
        else driver.distributor.isOnline = action.data.isOnline;
      } else {
        if (driver.isOnline !== action.data.isOnline) UpdateState = true;
        else driver.isOnline = action.data.isOnline;
      }
    }

    if (action.state === "UPDATE_DRIVER_MISSION_STATUS") {
      if (UserIsDistributor) {
        if (
          driver?.distributor?.MissionStatusOverView !==
          action.data?.driverLiveTrackMissionStatusOverView
        )
          UpdateState = true;
        else
          driver.distributor.MissionStatusOverView =
            action.data?.driverLiveTrackMissionStatusOverView;
      }
    } else {
      if (
        driver?.MissionStatusOverView !==
        action.data?.driverLiveTrackMissionStatusOverView
      )
        UpdateState = true;
      else
        driver.MissionStatusOverView =
          action.data?.driverLiveTrackMissionStatusOverView;
    }

    return {
      ...state,
      Drivers: state.Drivers.map((d) =>
        d.driverId === driver.driverId && d.clusterId === driver.clusterId
          ? driver
          : d
      ),
    };
  }

  if (action.state === "JUST_UPDATE_DRIVERS") {
    return {
      ...state,
      Drivers: action.data,
    };
  }

  if (!UpdateState) {
    return state;
  }
  return {
    ...state,
    Drivers: state.Drivers,
  };
};

export const updateSingleDriverInfo = (state, action) => {
  let DriverInfo = JSON.parse(JSON.stringify(state.SingleDriver));

  if (action.state === "MISSION_SOCKET_UPDATE") {
    if (state.SingleDriver) {
      if (state.SingleDriver.driverId === action.data.driverUserId) {
        DriverInfo.missions.forEach((mission) => {
          if (mission.packetId === action.data.packetId) {
            mission.missionStatus = action.data.missionStatus;
            mission.missionTime = action.data.missionTime;
          }
        });
      }
    }
  }

  if (action.state === "SET_DRIVER") {
    DriverInfo = {
      ...DriverInfo,
      ...action.data,
    };
  }

  if (action.state === "UPDATE_DRIVER" && state.SingleDriver) {
    DriverInfo = {
      ...action.data,
      missions: [...state.SingleDriver?.missions],
    };
  }

  if (action.state === "UPDATE_DRIVER_MISSIONS" && state.SingleDriver) {
    DriverInfo = {
      ...action.data,
    };
  }

  return {
    ...state,
    SingleDriver: DriverInfo,
  };
};

export const getDriverMissionInfo = (state, action) => {
  const updateValue = {
    request: action.data,
    response: state.DriverMissionInfo.response,
    error: null,
  };
  return { ...state, DriverMissionInfo: updateValue };
};
export const getDriverMissionInfoSuccess = (state, action) => {
  action.res.entity.clusterMissionCards[0].missions.sort((a, b) => {
    if (a.priority > b.priority) {
      return 1;
    }
    if (a.priority < b.priority) {
      return -1;
    }
    return 0;
  });
  const updateValue = {
    request: null,
    response: action.res.entity,
    error: null,
  };

  return {
    ...state,
    DriverMissionInfo: updateValue,
    missionInfoCount: {
      TOTAL: action.res.entity?.totalMissionsCount,
      ...action.res.entity?.missionStatusCounts,
    },
  };
};
export const getDriverMissionInfoFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };

  Notification.pushNotif(
    i18n.dir() === "rtl"
      ? action.error.response?.data?.messageFa
      : action.error.response?.data?.message,
    "error"
  );

  return { ...state, DriverMissionInfo: updateValue };
};

export const getDriverMissionInfoCount = (state, action) => {
  return { ...state };
};
export const getDriverMissionInfoCountSuccess = (state, action) => {
  return {
    ...state,
    missionInfoCount: {
      TOTAL: action.res.entity?.totalMissionsCount,
      ...action.res.entity?.missionStatusCounts,
    },
  };
};
export const getDriverMissionInfoCountFail = (state, action) => {
  Notification.pushNotif(
    i18n.dir() === "rtl"
      ? action.error.response?.data?.messageFa
      : action.error.response?.data?.message,
    "error"
  );

  return { ...state };
};

export const searchInLiveTrack = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, searchLiveTrack: updateValue };
};
export const searchInLiveTrackSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res,
    error: null,
  };

  return { ...state, searchLiveTrack: updateValue };
};
export const searchInLiveTrackFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };

  Notification.pushNotif(
    i18n.dir() === "rtl"
      ? action.error.response?.data?.messageFa
      : action.error.response?.data?.message,
    "error"
  );

  return { ...state, searchLiveTrack: updateValue };
};

export const getActualDeliveryMission = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, actualDelivery: updateValue };
};
export const getActualDeliveryMissionSuccess = (state, action) => {
  // Sort remain mission to end
  action.res?.entity.sort((a, b) => {
    if (a.missionStatus == 0) {
      if (b.missionStatus == 0) {
        if (a.priority > b.priority) {
          return 1;
        } else {
          return -1;
        }
      }
      return 0;
    } else {
      if (b.missionStatus != 0) {
        return 0;
      } else {
        return -1;
      }
    }
  });
  const updateValue = {
    request: null,
    response: action.res?.entity,
    error: null,
  };

  return { ...state, actualDelivery: updateValue };
};
export const getActualDeliveryMissionFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };

  Notification.pushNotif(
    i18n.dir() === "rtl"
      ? action.error.response?.data?.messageFa
      : action.error.response?.data?.message,
    "error"
  );

  return { ...state, actualDelivery: updateValue };
};

export const getActualRoute = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, ActualRoute: updateValue };
};
export const getActualRouteSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res?.entity,
    error: null,
    nullMissionIdRoute: action.res?.entityWithNullMissionId,
  };

  return { ...state, ActualRoute: updateValue };
};
export const getActualRouteFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };

  Notification.pushNotif(
    i18n.dir() === "rtl"
      ? action.error.response?.data?.messageFa
      : action.error.response?.data?.message,
    "error"
  );

  return { ...state, ActualRoute: updateValue };
};

export const changeMissionStatus = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, ChangeStatus: updateValue };
};
export const changeMissionStatusSuccess = (state, action) => {
  action.res.entity.clusterMissionCards[0].missions.sort((a, b) => {
    if (a.priority > b.priority) {
      return 1;
    }
    if (a.priority < b.priority) {
      return -1;
    }
    return 0;
  });
  const updateValue = {
    request: null,
    response: action.res,
    error: null,
  };

  return { ...state, ChangeStatus: updateValue };
};
export const changeMissionStatusFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };

  if (action.error?.response?.data?.message) {
    Notification.pushNotif(
      i18n.dir() === "rtl"
        ? action.error.response?.data?.messageFa
        : action.error.response?.data?.message,
      "error"
    );
  }

  return { ...state, ChangeStatus: updateValue };
};

export const getMissionInfo = (state, action) => {
  const updateValue = {
    request: action.data,
    error: null,
  };
  return { ...state, GetMissionInfo: { ...state.GetMissionInfo, updateValue } };
};
export const getMissionInfoSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res.entity,
    error: null,
  };

  return {
    ...state,
    GetMissionInfo: updateValue,
  };
};
export const getMissionInfoFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };

  if (action.error?.response?.data?.message) {
    Notification.pushNotif(
      i18n.dir() === "rtl"
        ? action.error.response?.data?.messageFa
        : action.error.response?.data?.message,
      "error"
    );
  }

  return { ...state, GetMissionInfo: updateValue };
};

export const getAllMissionPod = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, allMissionPOD: updateValue };
};
export const getAllMissionPodSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res,
    error: null,
  };

  return {
    ...state,
    allMissionPOD: updateValue,
  };
};
export const getAllMissionPodFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };

  if (action.error?.response?.data?.message) {
    Notification.pushNotif(
      i18n.dir() === "rtl"
        ? action.error.response?.data?.messageFa
        : action.error.response?.data?.message,
      "error"
    );
  }

  return { ...state, allMissionPOD: updateValue };
};

export const getLivetrackInfo = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, liveTrackInfo: updateValue };
};
export const getLivetrackInfoSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res?.entity,
    error: null,
  };

  return {
    ...state,
    liveTrackInfo: updateValue,
    wareHouse: action.res?.entity?.wareHouseCoordinates || [0, 0],
  };
};
export const getLivetrackInfoFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };

  if (action.error?.response?.data?.message) {
    Notification.pushNotif(
      i18n.dir() === "rtl"
        ? action.error.response?.data?.messageFa
        : action.error.response?.data?.message,
      "error"
    );
  }

  return { ...state, liveTrackInfo: updateValue };
};

export const getMissionConfirmation = (state, action) => {
  if (action.missionId) {
    // just one mission info
    return {
      ...state,
      SingleMissionConfirmation: {
        request: action.missionId,
        response: null,
        error: null,
      },
    };
  } else {
    // list of missions with confirmation
    return {
      ...state,
      MissionConfirmation: {
        request: true,
        response: state.MissionConfirmation.response || [],
        error: null,
      },
    };
  }
};
export const getMissionConfirmationSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res?.entity,
    error: null,
  };

  if (action.res?.entity?.packetId) {
    // just one mission info
    return {
      ...state,
      SingleMissionConfirmation: updateValue,
    };
  } else {
    // list of missions with confirmation
    return {
      ...state,
      MissionConfirmation: updateValue,
    };
  }
};
export const getMissionConfirmationFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };

  if (action.error?.response?.data?.message) {
    Notification.pushNotif(
      i18n.dir() === "rtl"
        ? action.error.response?.data?.messageFa
        : action.error.response?.data?.message,
      "error"
    );
  }

  return { ...state, MissionConfirmation: updateValue };
};

export const setMissionConfirmation = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, PostMissionConfirmation: updateValue };
};
export const setMissionConfirmationSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res,
    error: null,
  };
  return {
    ...state,
    PostMissionConfirmation: updateValue,
  };
};
export const setMissionConfirmationFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };

  if (action.error?.response?.data?.message) {
    Notification.pushNotif(
      i18n.dir() === "rtl"
        ? action.error.response?.data?.messageFa
        : action.error.response?.data?.message,
      "error"
    );
  }

  return { ...state, PostMissionConfirmation: updateValue };
};

export const changeMissionsOrder = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, ChangeMissionOrder: updateValue };
};
export const changeMissionsOrderSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res,
    error: null,
  };
  Notification.pushNotif(
    i18n.dir() === "rtl" ? action.res?.messageFa : action.res?.message,
    "success"
  );
  return {
    ...state,
    ChangeMissionOrder: updateValue,
  };
};
export const changeMissionsOrderFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };

  if (action.error?.response?.data?.message) {
    Notification.pushNotif(
      i18n.dir() === "rtl"
        ? action.error.response?.data?.messageFa
        : action.error.response?.data?.message,
      "error"
    );
  }

  return { ...state, ChangeMissionOrder: updateValue };
};
